// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.label_Bcix_ {
  font: 600 13px/20px Inter;
  color: var( --color-base700 );
  padding-top: 4px;
}
.label_Bcix_.label-inputTitle_UUZ5d {
  font: 600 13px/20px Inter;
  color: var( --color-base700 );
}
.label_Bcix_.label-inputTitle_UUZ5d.label-checkboxTitle__IAHE {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.label_Bcix_.label-inputCaption_pNvRG {
  font: 13px/20px Inter;
  color: #67798e;
}
.label_Bcix_.label-input_JPiNT {
  font: normal 13px/20px Inter;
  color: var( --color-base900 );
  padding-top: 0px;
}
.label_Bcix_.label-touchToolbarLabel_I7GxM {
  font: 13px/20px Inter;
  color: var( --color-base700 );
}
.label_Bcix_.label-checkboxLabel_ZAm5N {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.label_Bcix_.label-mobileUserNavBarNested_jW29_ {
  color: var( --color-base700 );
  font-size: 16px;
  line-height: 24px;
  padding-top: var( --size-pad12 );
  padding-left: var( --size-padMedium );
  padding-bottom: var( --size-pad12 );
}
.label_Bcix_.label-checkboxLabelWrap_Kj2pY {
  font: normal 13px/20px Inter;
  color: #495a6e;
  overflow: unset;
  white-space: normal;
  text-overflow: unset;
}
.label_Bcix_.label-subtitle_NsdX5 {
  font: bold 16px/24px Inter;
  color: #394756;
  padding-top: var( --size-padLarge );
  padding-bottom: var( --size-padLarge );
}
.label_Bcix_.label-captionSmallBold_B1s_z {
  font: 600 12px/18px Inter;
  color: #67798e;
}
.label_Bcix_.label-captionSmall_gh3fp {
  font: normal 12px/18px Inter;
  color: #67798e;
}
.label_Bcix_.label-inputCaption_pNvRG.label-helperText_ENU4C {
  color: var( --color-base500 );
}
.label_Bcix_.label-caption_bL2SP {
  font: 13px/20px Inter;
  color: #67798e;
}
.label_Bcix_.label-large_HI37J {
  color: #394656;
  font-size: var( --size-bodyLarge );
  font-weight: 600;
}
.label_Bcix_.label-propGrid_XI0Fe {
  font: 600 13px/20px Inter;
  color: var( --color-base700 );
  padding-top: 6px;
}
.label_Bcix_.label-loginHeader_a8hdG {
  color: var( --color-base700 );
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/theme/Label.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,6BAA6B;EAC7B,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,qCAAqC;EACrC,mCAAmC;AACrC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,cAAc;AAChB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,cAAc;EACd,kCAAkC;EAClC,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB","sourcesContent":[".label {\n  font: 600 13px/20px Inter;\n  color: var( --color-base700 );\n  padding-top: 4px;\n}\n.label.label-inputTitle {\n  font: 600 13px/20px Inter;\n  color: var( --color-base700 );\n}\n.label.label-inputTitle.label-checkboxTitle {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.label.label-inputCaption {\n  font: 13px/20px Inter;\n  color: #67798e;\n}\n.label.label-input {\n  font: normal 13px/20px Inter;\n  color: var( --color-base900 );\n  padding-top: 0px;\n}\n.label.label-touchToolbarLabel {\n  font: 13px/20px Inter;\n  color: var( --color-base700 );\n}\n.label.label-checkboxLabel {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.label.label-mobileUserNavBarNested {\n  color: var( --color-base700 );\n  font-size: 16px;\n  line-height: 24px;\n  padding-top: var( --size-pad12 );\n  padding-left: var( --size-padMedium );\n  padding-bottom: var( --size-pad12 );\n}\n.label.label-checkboxLabelWrap {\n  font: normal 13px/20px Inter;\n  color: #495a6e;\n  overflow: unset;\n  white-space: normal;\n  text-overflow: unset;\n}\n.label.label-subtitle {\n  font: bold 16px/24px Inter;\n  color: #394756;\n  padding-top: var( --size-padLarge );\n  padding-bottom: var( --size-padLarge );\n}\n.label.label-captionSmallBold {\n  font: 600 12px/18px Inter;\n  color: #67798e;\n}\n.label.label-captionSmall {\n  font: normal 12px/18px Inter;\n  color: #67798e;\n}\n.label.label-inputCaption.label-helperText {\n  color: var( --color-base500 );\n}\n.label.label-caption {\n  font: 13px/20px Inter;\n  color: #67798e;\n}\n.label.label-large {\n  color: #394656;\n  font-size: var( --size-bodyLarge );\n  font-weight: 600;\n}\n.label.label-propGrid {\n  font: 600 13px/20px Inter;\n  color: var( --color-base700 );\n  padding-top: 6px;\n}\n.label.label-loginHeader {\n  color: var( --color-base700 );\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `label_Bcix_`,
	"label-inputTitle": `label-inputTitle_UUZ5d`,
	"label-checkboxTitle": `label-checkboxTitle__IAHE`,
	"label-inputCaption": `label-inputCaption_pNvRG`,
	"label-input": `label-input_JPiNT`,
	"label-touchToolbarLabel": `label-touchToolbarLabel_I7GxM`,
	"label-checkboxLabel": `label-checkboxLabel_ZAm5N`,
	"label-mobileUserNavBarNested": `label-mobileUserNavBarNested_jW29_`,
	"label-checkboxLabelWrap": `label-checkboxLabelWrap_Kj2pY`,
	"label-subtitle": `label-subtitle_NsdX5`,
	"label-captionSmallBold": `label-captionSmallBold_B1s_z`,
	"label-captionSmall": `label-captionSmall_gh3fp`,
	"label-helperText": `label-helperText_ENU4C`,
	"label-caption": `label-caption_bL2SP`,
	"label-large": `label-large_HI37J`,
	"label-propGrid": `label-propGrid_XI0Fe`,
	"label-loginHeader": `label-loginHeader_a8hdG`
};
export default ___CSS_LOADER_EXPORT___;
